var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon / Right"},React.createElement("g",{"id":"Icon"},[React.createElement("path",{"d":"M3.00292 6.39811L9.99995 9.89663L16.9971 6.39807C16.9443 5.47901 16.1823 4.75 15.25 4.75H4.75C3.8177 4.75 3.05568 5.47903 3.00292 6.39811Z","fill":"white","key":0}),React.createElement("path",{"d":"M17 8.35317L9.99995 11.8532L3 8.35321V13.5C3 14.4665 3.7835 15.25 4.75 15.25H15.25C16.2165 15.25 17 14.4665 17 13.5V8.35317Z","fill":"white","key":1})])));
}

Mail.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
